import { useFeatureFlagEnabled } from '@/features/flags/posthog-compat';

/**
 * Rollout gate for the Patient Digital Twin inspector. PostHog, default OFF.
 *
 * The same key gates ml-scribe's `POST /api/v2/ml-scribe/patient-state/views`
 * route, deliberately: a frontend that could render the inspector for a caller
 * the backend refuses would show an empty panel where the honest answer is “not
 * enabled for you”, and R6's whole acceptance bar is telling those apart.
 *
 * Lives in its own leaf module rather than the `index.tsx` barrel so it adds no
 * `react-refresh/only-export-components` warning to that file; the barrel
 * re-exports it, so call sites still import from `@/features/flags`.
 */
export const PATIENT_DIGITAL_TWIN_FLAG_KEY = 'release-na-fde-patient-digital-twin';

export const useIsPatientDigitalTwinEnabled = () => {
  return useFeatureFlagEnabled(PATIENT_DIGITAL_TWIN_FLAG_KEY) ?? false;
};
